module.exports = __webpack_public_path__ + "static/media/linux_icon_store.716c47c0.png";